import React from "react";
import HajjUmrahForm from "../Components/HajjUmrahForm";

function HajjUmrah(){
    return(
        <>
        <section className="breadcrumb-main pb-15 pt-15 bookingHeaderSection" >
            <div className="section-shape section-shape1 top-inherit bottom-0" ></div>
            <div className="breadcrumb-outer">
                <div className="container">
                    <div className="breadcrumb-content text-center">
                        <h1 className="mb-3">Hajj & Umrah</h1>
                    </div>
                    <div className="row" >
                        <HajjUmrahForm />
                    </div>
                </div>
            </div>
        </section>
        </>
    )
}
export default HajjUmrah;